/* InstaCuppa A+ carousel: scroll-snap track + arrows + dots + keyboard. Inits every [data-ic-carousel] once. 2026-10-06 */
(function(){
  'use strict';
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(root){
    if(root.getAttribute('data-ic-ready')==='1')return;
    var track=root.querySelector('[data-ic-track]');
    var slides=Array.prototype.slice.call(root.querySelectorAll('[data-ic-slide]'));
    if(!track||slides.length<2)return;
    root.setAttribute('data-ic-ready','1');
    var prev=root.querySelector('[data-ic-prev]'),next=root.querySelector('[data-ic-next]');
    var dotsWrap=root.querySelector('[data-ic-dots]');
    var dots=Array.prototype.slice.call(root.querySelectorAll('[data-ic-dot]'));
    var idx=0,ticking=false;
    function width(){return track.clientWidth||1;}
    function current(){return Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/width())));}
    function update(){
      ticking=false;
      if(!track.clientWidth)return;
      idx=current();
      dots.forEach(function(d,j){if(j===idx)d.setAttribute('aria-current','true');else d.removeAttribute('aria-current');});
      if(prev)prev.disabled=idx===0;
      if(next)next.disabled=idx===slides.length-1;
    }
    function go(i,instant){
      i=Math.max(0,Math.min(slides.length-1,i));
      track.scrollTo({left:i*width(),behavior:(reduce||instant)?'auto':'smooth'});
      idx=i;
    }
    track.addEventListener('scroll',function(){if(!ticking){ticking=true;window.requestAnimationFrame(update);}},{passive:true});
    if(prev)prev.addEventListener('click',function(){go(idx-1);});
    if(next)next.addEventListener('click',function(){go(idx+1);});
    dots.forEach(function(d,j){d.addEventListener('click',function(){go(j);});});
    root.addEventListener('keydown',function(e){
      if(e.key==='ArrowLeft'){e.preventDefault();go(idx-1);}
      else if(e.key==='ArrowRight'){e.preventDefault();go(idx+1);}
    });
    var lastW=track.clientWidth;
    function onResize(){var w=track.clientWidth;if(w&&w!==lastW){lastW=w;go(idx,true);}update();}
    if('ResizeObserver' in window)new ResizeObserver(onResize).observe(track);else window.addEventListener('resize',onResize);
    [prev,next,dotsWrap].forEach(function(el){if(el)el.removeAttribute('hidden');});
    update();
  }
  function boot(){Array.prototype.forEach.call(document.querySelectorAll('[data-ic-carousel]'),init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
